<button mat-button (click)="exportOptions()" [disabled]="disabledForUpsell"
  [attr.aria-label]="hideLabel ? ('export.export' | translate) : null"
  [ngClass]="{'disabled-for-upsell': disabledForUpsell}">
  <mat-icon>cloud_download</mat-icon>
  <span fxHide.lt-sm *ngIf="!hideLabel" class="export-text">
    {{ 'export.export' | translate }}
  </span>
  <div class="full-cover" [matTooltip]="(disabledForUpsell ? 'common.upsellTooltip': 'export.button') | translate">
  </div>
</button>
